import keyMirror from 'keymirror-nested'

export default keyMirror({
  STEPPER: {
    UPDATE: null,
    CLEAR: null,
  },
})
